import { getMessage } from '@tcc/i18n';
import { Operation } from '../hooks/useOperations/types';
import { ALL_OPERATIONS } from './operations';

const removeAllOperationsItem = ({ operationId }: { operationId: string }) => operationId !== ALL_OPERATIONS;

type OperationSelectorDisplayText = {
  operations: Operation[];
  operationsSelected: Operation[];
}

export function getOperationSelectorDisplayText({
  operations,
  operationsSelected
}: OperationSelectorDisplayText): string {

  const operationsWithoutAllId = operations.filter(removeAllOperationsItem);
  const selectedOperationsWithoutAllId = operationsSelected.filter(removeAllOperationsItem);
  const areAllOperationsSelected = operationsWithoutAllId.length === selectedOperationsWithoutAllId.length;

  const userHasOneOperation = operations.length === 2;

  const allOperationsSelectedSingleOperation = operationsSelected.length && operationsSelected[0].operationId === 'all-operations';
  const allOperationsSelectedMultiOperation = areAllOperationsSelected;
  
  if ((allOperationsSelectedSingleOperation || allOperationsSelectedMultiOperation) && !userHasOneOperation) {
    return getMessage('sidenav.allOperations');
  }
  if (operationsSelected.length === 1) {
    return userHasOneOperation ? operations[1].operationName: operationsSelected[0].operationName;
  }
  return getMessage('sidenav.operations', {num: operationsSelected.length});
}